// utils
import { CUSTOM_FIELD_MAPPING } from './mappings';

export const getCustomFieldType = (type) => CUSTOM_FIELD_MAPPING[type] ?? null;
